import React from 'react';

const Badge = ({
  variant = 'default',
  size = 'medium',
  children,
  className = '',
  ...props
}) => {
  const baseClasses = 'inline-flex items-center font-medium rounded-full';
  
  const sizeClasses = {
    small: 'px-2 py-0.5 text-xs',
    medium: 'px-2.5 py-0.5 text-sm',
    large: 'px-3 py-1 text-sm'
  };
  
  const variantClasses = {
    default: 'bg-gray-100 text-gray-800',
    primary: 'bg-primary-100 text-primary-800',
    secondary: 'bg-gray-100 text-gray-600',
    success: 'bg-green-100 text-green-800',
    warning: 'bg-yellow-100 text-yellow-800',
    danger: 'bg-red-100 text-red-800',
    info: 'bg-blue-100 text-blue-800'
  };
  
  return (
    <span 
      className={`${baseClasses} ${sizeClasses[size]} ${variantClasses[variant]} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
};

const StatusBadge = ({ 
  status, 
  size = 'medium', 
  className = '', 
  ...props 
}) => {
  const statusConfig = {
    active: { variant: 'success', label: 'Active' },
    inactive: { variant: 'secondary', label: 'Inactive' },
    pending: { variant: 'warning', label: 'Pending' },
    approved: { variant: 'success', label: 'Approved' },
    rejected: { variant: 'danger', label: 'Rejected' },
    draft: { variant: 'secondary', label: 'Draft' },
    published: { variant: 'success', label: 'Published' },
    archived: { variant: 'secondary', label: 'Archived' },
    processing: { variant: 'info', label: 'Processing' },
    completed: { variant: 'success', label: 'Completed' },
    failed: { variant: 'danger', label: 'Failed' }
  };
  
  const config = statusConfig[status] || { variant: 'default', label: status };
  
  return (
    <Badge 
      variant={config.variant} 
      size={size} 
      className={className}
      {...props}
    >
      {config.label}
    </Badge>
  );
};

export default Badge;
export { StatusBadge };